import { render, staticRenderFns } from "./StockTransformations.vue?vue&type=template&id=40a5e9fa&"
import script from "./StockTransformations.vue?vue&type=script&lang=js&"
export * from "./StockTransformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports